export default __webpack_public_path__ + "assets/images/473259d486709d83833d210bc3e4a6b1.png";